import { render, staticRenderFns } from "./AssistantCardSkeleton.vue?vue&type=template&id=6909f675&scoped=true&"
import script from "./AssistantCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./AssistantCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./AssistantCardSkeleton.vue?vue&type=style&index=0&id=6909f675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6909f675",
  null
  
)

export default component.exports